import type {
  AvatarCallSurfaceMode,
  AvatarContextualChatHistoryRole,
  AvatarContextualChatHistoryTurn,
  AvatarContextualChatSeed,
  AvatarLiveSessionKind,
  AvatarLiveAssistantProfile,
  AvatarLiveFallbackMode,
  AvatarSessionContext,
  AvatarSessionMode,
  AvatarSessionState,
  AvatarSessionStatus,
  AvatarSessionUpdate,
  AvatarTransportKind
} from './types';

export type {
  AvatarCallSurfaceMode,
  AvatarContextualChatHistoryRole,
  AvatarContextualChatHistoryTurn,
  AvatarContextualChatSeed,
  AvatarLiveSessionKind,
  AvatarLiveAssistantProfile,
  AvatarLiveFallbackMode,
  AvatarSessionContext,
  AvatarSessionMode,
  AvatarSessionState,
  AvatarSessionStatus,
  AvatarSessionUpdate,
  AvatarTransportKind
} from './types';

export { callSurfaceModeToSessionMode } from './types';

export {
  buildContextualChatMetadata,
  createContextualChatSessionContext,
  createLiveSessionContext,
  normalizeLiveSessionKind
} from './liveMode';

export function createAvatarSessionState(
  context: AvatarSessionContext = {},
  options: Partial<Omit<AvatarSessionState, 'context'>> = {}
): AvatarSessionState {
  return {
    status: options.status ?? 'idle',
    mode: options.mode ?? 'voice-avatar',
    transport: options.transport ?? 'native',
    context,
    lastError: options.lastError
  };
}
